"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Teams = exports.TeamList = void 0;
var TeamList;
(function (TeamList) {
    TeamList["ari"] = "Arizona Diamondbacks";
    TeamList["atl"] = "Atlanta Braves";
    TeamList["bal"] = "Baltimore Orioles";
    TeamList["bos"] = "Boston Red Sox";
    TeamList["chc"] = "Chicago Cubs";
    TeamList["cws"] = "Chicago White Sox";
    TeamList["cin"] = "Cincinnati Reds";
    TeamList["cle"] = "Cleveland Indians";
    TeamList["col"] = "Colorado Rockies";
    TeamList["det"] = "Detroit Tigers";
    TeamList["mia"] = "Miami Marlins";
    TeamList["hou"] = "Houston Astros";
    TeamList["kc"] = "Kansas City Royals";
    TeamList["laa"] = "Los Angeles Angels";
    TeamList["la"] = "Los Angeles Dodgers";
    TeamList["mil"] = "Milwaukee Brewers";
    TeamList["min"] = "Minnesota Twins";
    TeamList["nym"] = "New York Mets";
    TeamList["nyy"] = "New York Yankees";
    TeamList["oak"] = "Oakland Athletics";
    TeamList["phi"] = "Philadelphia Phillies";
    TeamList["pit"] = "Pittsburgh Pirates";
    TeamList["sd"] = "San Diego Padres";
    TeamList["sf"] = "San Francisco Giants";
    TeamList["sea"] = "Seattle Mariners";
    TeamList["stl"] = "St. Louis Cardinals";
    TeamList["tb"] = "Tampa Bay Rays";
    TeamList["tex"] = "Texas Rangers";
    TeamList["tor"] = "Toronto Blue Jays";
    TeamList["was"] = "Washington Nationals";
})(TeamList || (exports.TeamList = TeamList = {}));
var Teams = /** @class */ (function () {
    function Teams() {
    }
    Teams.TeamList = TeamList;
    Teams.TeamIdList = {
        108: "laa",
        109: "ari",
        110: "bal",
        111: "bos",
        112: "chc",
        113: "cin",
        114: "cle",
        115: "col",
        116: "det",
        117: "hou",
        118: "kc",
        119: "la",
        120: "was",
        121: "nym",
        133: "oak",
        134: "pit",
        135: "sd",
        136: "sea",
        137: "sf",
        138: "stl",
        139: "tb",
        140: "tex",
        141: "tor",
        142: "min",
        143: "phi",
        144: "atl",
        145: "chw",
        146: "mia",
        147: "nyy",
        158: "mil",
        "laa": 108,
        "ari": 109,
        "bal": 110,
        "bos": 111,
        "chc": 112,
        "cin": 113,
        "cle": 114,
        "col": 115,
        "det": 116,
        "hou": 117,
        "kc": 118,
        "la": 119,
        "was": 120,
        "nym": 121,
        "oak": 133,
        "pit": 134,
        "sd": 135,
        "sea": 136,
        "sf": 137,
        "stl": 138,
        "tb": 139,
        "tex": 140,
        "tor": 141,
        "min": 142,
        "phi": 143,
        "atl": 144,
        "chw": 145,
        "cws": 145,
        "mia": 146,
        "nyy": 147,
        "mil": 158,
    };
    return Teams;
}());
exports.Teams = Teams;
